export default __webpack_public_path__ + "static/media/MiniTape_SideA_06_Intermission_Interview.b326b6e5.mp3";